module.exports = __webpack_public_path__ + "static/media/page3-back.c79fdd46.png";